import React from "react";
import { Textarea } from "../UI/FormField";

/**
 * One note on the review page — a driver's instruction for a stop, or the
 * notes that travel with the order or the container.
 *
 * Oliver's notes range from four words to a wall of standing instructions, and
 * both have to sit in a grid beside each other. So: one line to start, growing
 * with the text, and never taller than three lines — past that the box keeps
 * its place in the layout and the reader scrolls inside it.
 *
 * `leading-5` is deliberate: the three-line ceiling is measured off the line
 * height, and an unset one ("normal") is only ever an approximation.
 */
const IntakeNote: React.FC<React.ComponentProps<typeof Textarea>> = (props) => (
  <Textarea rows={1} autoGrow maxRows={3} {...props} className={`leading-5 ${props.className ?? ""}`} />
);

export default IntakeNote;
